import moment, { DurationFormatSettings } from 'moment';

export const formatDuration = (
  value: string,
  signed = true,
  format = 'h:mm',
  formatSettings: DurationFormatSettings = { trim: false },
) => {
  const duration = moment.duration(value);

  return `${
    signed && duration.asMilliseconds() > 0 ? '+' : ''
  }${duration.format(format, formatSettings)}`;
};
